import Vue from "vue";
import VueRouter from "vue-router";
import Signup from "@/components/auth/Signup.vue";
import Login from "@/components/auth/Login.vue";
import Groups from "@/components/Groups.vue";
import Password from "@/components/auth/ResetPassword.vue";
import NewPassword from "@/components/auth/NewPassword.vue";
import Referral from "@/components/auth/ReferralCode.vue";
import EmailSent from "@/components/auth/EmailSent.vue";
import SetPassword from "@/components/auth/SetPassword.vue";
import ActionHandlers from "@/components/auth/ActionHandlers.vue";
import SetUp from "@/components/auth/AccountSetUp.vue";
import Reviews from "@/views/main/Reviews.vue";
import Upload from "@/views/main/Upload.vue";
import Portal from "@/views/Portal.vue";
import Landingpage from "@/views/Landing/Landingpage.vue";
import EmailLandingPage from "@/views/Landing/EmailLandingPage.vue";
import Ambassadors from "@/views/Landing/Ambassadors.vue";
import AmbassadorPortal from "@/views/Landing/AmbassadorPortal.vue";
import ProfileCalendar from "@/views/Profiles/ProfileCalendar.vue";
import ProfileSettings from "@/views/Profiles/ProfileSettings.vue";
import Terms from "@/views/auth/Terms.vue";
import ContestTerms from "@/views/Landing/ContestTerms.vue";
import AddCourse from "@/views/AddCourse.vue";
import Privacy from "@/views/auth/Privacy.vue";
import Analytics from "@/views/Analytics.vue";
import store from "../store";
import db from "@/db";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Landingpage",
    component: Landingpage,
    beforeEnter: (to, from, next) => {
      var user = store.state.user.user;
      if (!user.id) {
        next();
      } else {
        next({ name: "MessageBoard" });
        /*
        if (user.courses.length > 0) {
          store.commit("messageBoard/setGroupId", user.courses[0].id);
          next({
            name: "MessageBoard",
            params: {
              name: user.courses[0].name.replace(/\s/g, "-"),
              id: user.courses[0].id,
            },
          });
        } else if (user.faculties.length > 0) {
          store.commit("messageBoard/setGroupId", user.faculties[0].id);
          next({
            name: "MessageBoard",
            params: {
              name: user.faculties[0].name.replace(/\s/g, "-"),
              id: user.faculties[0].id,
            },
          });
        } else if (user.groups.length > 0) {
          store.commit("messageBoard/setGroupId", user.groups[0].id);
          next({
            name: "MessageBoard",
            params: {
              name: user.groups[0].name.replace(/\s/g, "-"),
              id: user.groups[0].id,
            },
          });
        } else if (user.directMessages.length > 0) {
          store.commit("messageBoard/setGroupId", user.directMessages[0].id);
          next({
            name: "MessageBoard",
            params: {
              name: user.directMessages[0].name.replace(/\s/g, "-"),
              id: user.directMessages[0].id,
            },
          });
        } else {
          next({ name: "MessageBoard" });
        }*/
      }
    },
  },
  {
    path: "/schools",
    name: "EmailLandingPage",
    component: EmailLandingPage,
  },
  {
    path: "/ambassadors",
    name: "Ambassadors",
    component: Ambassadors,
  },
  {
    path: "/myPortal/:id",
    name: "AmbassadorPortal",
    component: AmbassadorPortal,
    props: true,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/signup/:uid?",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/passwordUpdated",
    name: "NewPassword",
    component: NewPassword,
  },
  {
    path: "/review",
    name: "Reviews",
    component: Reviews,
  },
  {
    path: "/upload",
    name: "Upload",
    component: Upload,
  },
  {
    path: "/reset-password",
    name: "Password",
    component: Password,
  },
  {
    path: "/email-sent",
    name: "EmailSent",
    component: EmailSent,
    props: true,
  },
  {
    path: "/add-referral",
    name: "Referral",
    component: Referral,
  },
  {
    path: "/account-setup",
    name: "SetUp",
    component: SetUp,
  },
  {
    path: "/groups",
    name: "Groups",
    component: Groups,
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms,
  },
  {
    path: "/contest/terms&conditions",
    name: "ContestTerms",
    component: ContestTerms,
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
  },
  {
    path: "/analytics",
    name: "Analytics",
    component: Analytics,
  },
  {
    path: "/settings",
    name: "Settings",
    component: ProfileSettings,
  },
  {
    path: "/profile",
    name: "Profile",
    component: () => import("@/views/Profiles/Profile.vue"),
    beforeEnter: (to, from, next) => {
      let user = store.state.user.user;
      if (!user || Object.keys(user).length == 0) {
        next({ name: "Login" });
      } else {
        next();
      }
    },
  },
  {
    path: "/profileCalendar",
    name: "ProfileCalendar",
    component: ProfileCalendar,
  },
  {
    path: "/profile/:userName",
    name: "PublicProfile",
    component: () => import("@/views/Profiles/PublicProfile.vue"),
    props: true,
  },
  {
    path: "/discover",
    name: "Discover",
    component: () => import("@/views/Discover.vue"),
  },
  {
    path: "/discover/:category",
    name: "MoreGroups",
    component: () => import("@/views/MoreGroups.vue"),
    props: true,
  },
  {
    path: "/courses",
    name: "AddCourse",
    component: AddCourse,
  },
  {
    path: "/emailVerified",
    name: "ActionHandlers",
    component: ActionHandlers,
  },
  {
    path: "/set-password",
    name: "SetPassword",
    component: SetPassword,
  },
  {
    path: "/myPortal",
    name: "Portal",
    component: Portal,
  },
  {
    path: "/calendar/:name/:id",
    name: "Calendar",
    component: () => import("@/views/main/Calendar.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      let user = store.state.user.user;
      let id = to.params.name;

      if (!user) {
        next({ name: "Login" });
      }

      var isAllowed = false;
      for (const index in user.courses) {
        if (user.courses[index].name.replace(/\s/g, "-") == id) {
          isAllowed = true;
        }
      }

      for (const index in user.faculties) {
        if (user.faculties[index].name.replace(/\s/g, "-") == id) {
          isAllowed = true;
        }
      }

      for (const index in user.groups) {
        if (user.groups[index].name.replace(/\s/g, "-") == id) {
          isAllowed = true;
        }
      }
      isAllowed ? next() : next({ name: "Login" });
    },
  },
  {
    path: "/share/:type/:id",
    redirect: (to) => {
      const { params } = to;
      var type = "";
      switch (params.type) {
        case "group":
          type = "groups";
          break;
        case "course":
          type = "courses";
          break;
        case "program":
          type = "faculties";
          break;
      }
      db.collection(type)
        .doc(params.id)
        .get()
        .then((doc) => {
          router.push({
            name: "MessageBoard",
            params: {
              name: doc.data().name.replace(" ", "-"),
              type: type,
              id: params.id,
            },
          });
        });
    },
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("@/views/Landing/Test.vue"),
  },
  {
    path: "/contest",
    name: "Contest",
    component: () => import("@/views/Landing/Contest.vue"),
  },
  {
    path: "/_/",
    redirect: () => {
      window.location.replace("https://courselnk.com/contest");
    },
  },
  {
    path: "/:name/:type/:id",
    name: "MessageBoard",
    component: () => import("@/views/main/MessageBoard.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      let user = store.state.user.user;
      var phone = false;
      var iOS =
        [
          "iPad Simulator",
          "iPhone Simulator",
          "iPod Simulator",
          "iPad",
          "iPhone",
          "iPod",
        ].includes(navigator.platform) ||
        // iPad on iOS 13 detection
        (navigator.userAgent.includes("Mac") && "ontouchend" in document);
      //let id = to.params.id;
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        phone = true;
      }
      if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        phone = true;
      }

      if (!user || Object.keys(user).length == 0) {
        if (phone) {
          if (iOS) {
            window.location.replace(
              "https://apps.apple.com/ca/app/courselnk/id1545799969"
            );
          } else {
            window.location.replace(
              "https://play.google.com/store/apps/details?id=com.courselnk.courselnkandroid.App"
            );
          }
        } else {
          next({ name: "Login" });
        }
      } else {
        next();
      }
      /*
      var isAllowed = false;
      if (user.courses.length > 0) {
        for (const index in user.courses) {
          if (user.courses[index].id == id) {
            isAllowed = true;
          }
        }
      }
      if (user.faculties.length > 0) {
        for (const index in user.faculties) {
          if (user.faculties[index].id == id) {
            isAllowed = true;
          }
        }
      }
      if (user.groups.length > 0) {
        for (const index in user.groups) {
          if (user.groups[index].id == id) {
            isAllowed = true;
          }
        }
      }
      if (user.directMessages) {
        if (user.directMessages.length > 0) {
          for (const index in user.directMessages) {
            if (user.directMessages[index].id == id) {
              isAllowed = true;
            }
          }
        }
      }
      isAllowed ? next() : next({ name: "Login" });*/
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
